import Vue from 'vue'


export const createComponentProgrammatic = async (AsyncComponent, parent, propsData) => {
  const { default: resolvedComponent } = await AsyncComponent
  const element = document.createElement('div')
  parent.$el.appendChild(element)

  const listeners = propsData?.on
  if (listeners) {
    // eslint-disable-next-line no-param-reassign
    delete propsData.on
  }

  const vm = new Vue({
    el: element,
    name: `global-${resolvedComponent.name}`,
    parent,
    inheritAttrs: false,
    data: propsData,
    computed: {
      options() {
        const base = {
          props: this.$data,
          attrs: this.$data,
          ref: 'modal',
        }
        if (listeners) {
          base.on = listeners
        }
        return base
      },
    },
    mounted() {
      this.$refs.modal.$once('closed', this.onClosed)
    },
    methods: {
      open(flag) {
        return this.$refs.modal.open(flag)
      },
      close(flag) {
        return this.$refs.modal.close(flag)
      },
      onClosed(payload) {
        this.$emit('closed', payload)
      },
    },
    render(h) {
      return h(resolvedComponent, this.options)
    },
  })

  parent.$once('hook:beforeDestroy', vm.close)

  vm.$once('closed', () => {
    parent.$off('hook:beforeDestroy', vm.close)
    setTimeout(() => {
      vm.$destroy()
      // vm.$el.remove()
    }, 1000)
  })

  return vm
}
